export default __webpack_public_path__ + "static/q_mylee-a5b0f232abc55ab504eb5b458765fce4.png";